// 지식베이스 관리(대표) API — 계약 §9. 문서 /knowledge, 매장 /customer.
import { http, data } from "../../inquiry/v6Api";
export { errorText } from "../../inquiry/v6Api";

// 서버 목록 상한(limit ≤ 100). 문서는 쪽 없이 한 번에 받는다.
const MAX = 100;
const clean = (o) => Object.fromEntries(Object.entries(o).filter(([, v]) => v !== "" && v != null && v !== false));
const oneFile = (f) => { const form = new FormData(); form.append("file", f); return form; };

export const listDocs = (params = {}) => data(http.get("/knowledge/", { params: { ...clean(params), limit: MAX } }));
export const uploadDoc = (file) => data(http.post("/knowledge/uploads", oneFile(file)));
export const deleteDoc = (id) => http.delete(`/knowledge/${id}`);
export const bulkDeleteDocs = (ids) => data(http.post("/knowledge/bulk-delete", { ids }));


export function listStores({ q = "", page = 1, size = 10, noMobile = false } = {}) {
    const k = q.trim();
    const params = { offset: (page - 1) * size, limit: size, ...clean({ q: k, no_mobile: noMobile }) };
    return data(http.get(k ? "/customer/search" : "/customer/", { params }));
}
export const storeStats = () => data(http.get("/customer/stats"));
export const createStore = (body) => data(http.post("/customer/", body));
export const uploadCsv = (file) => data(http.post("/customer/upload_csv", oneFile(file)));
export const bulkDeleteStores = (ids) => data(http.post("/customer/bulk_delete", { ids }));
